// FIXME Should be obsolete with typescript
import {
    LOANFORMAT_ALL_OBJECT,
    LOANFORMAT_EAUDIOBOOK_OBJECT,
    LOANFORMAT_EBOOK_OBJECT,
    LOANFORMAT_EMAGAZINES_OBJECT,
    LOANFORMAT_EPRESS_OBJECT
} from './constants';
import toLower from 'lodash/toLower';
import find from 'lodash/find';
import { LoanFormatState } from '../../app-store/loanFormat/loanFormatReducer';
import { parseLoanFormat } from '../../../models/LoanFormat';

export function getConcreteLoanFormatStates(): LoanFormatState[] {
    return [LOANFORMAT_EAUDIOBOOK_OBJECT, LOANFORMAT_EBOOK_OBJECT, LOANFORMAT_EPRESS_OBJECT];
}

export function getLoanFormatStates(): LoanFormatState[] {
    return [LOANFORMAT_EAUDIOBOOK_OBJECT, LOANFORMAT_EBOOK_OBJECT, LOANFORMAT_EPRESS_OBJECT, LOANFORMAT_ALL_OBJECT];
}

export function loanFormatKeyToObject(key: string): LoanFormatState {
    const parsedLoanFormat = parseLoanFormat(key);

    if (!parsedLoanFormat) {
        return LOANFORMAT_ALL_OBJECT;
    }

    return getLoanFormatStates().find(val => toLower(parsedLoanFormat) === toLower(val.key)) ?? LOANFORMAT_ALL_OBJECT;
}

export function concreteLoanFormatNameToKey(name: string | null): string {
    const loanFormat = find([...getConcreteLoanFormatStates(), LOANFORMAT_EMAGAZINES_OBJECT], { name: name ?? '' });

    if (loanFormat?.key === LOANFORMAT_EMAGAZINES_OBJECT.key) {
        return LOANFORMAT_EPRESS_OBJECT.key;
    }

    return loanFormat?.key ?? '';
}

export function concreteLoanFormatNameToObject(name: string): LoanFormatState | undefined {
    const result = find([...getConcreteLoanFormatStates(), LOANFORMAT_EMAGAZINES_OBJECT], { name });

    if (result?.key === LOANFORMAT_EMAGAZINES_OBJECT.key) {
        return LOANFORMAT_EPRESS_OBJECT;
    }

    return result;
}

export function concreteLoanFormatKeyToObject(key: string): LoanFormatState | undefined {
    const result = find([...getConcreteLoanFormatStates(), LOANFORMAT_EMAGAZINES_OBJECT], { key });

    if (result?.key === LOANFORMAT_EMAGAZINES_OBJECT.key) {
        return LOANFORMAT_EPRESS_OBJECT;
    }

    return result;
}
